import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SortableService {
	dragging$ = new Subject<boolean>();
	dragSource$ = new Subject<DragSource | undefined>();
	dropSource$ = new Subject<Element | undefined>();
}
export interface DragSource {
	element: Element;
	item: any;
}
